<template>
  <div class="footer">
    <div class="quick">
      <div class="quick-col">
        <div class="quick-col-title">AI教育云平台</div>
        <div v-for="(item, index) in education_list" :key="index" class="quick-col-item" @click="handleClick(item)">{{ item.name }}</div>
      </div>
      <div class="quick-col">
        <div class="quick-col-title">AI教育产品</div>
        <div v-for="(item, index) in product_list" :key="index" class="quick-col-item" @click="handleClick(item)">{{ item.name }}</div>
      </div>
      <div class="quick-col">
        <div class="quick-col-title">AI教育方案</div>
        <div v-for="(item, index) in scheme_list" :key="index" class="quick-col-item" @click="handleClick(item)">{{ item.name }}</div>
      </div>
      <div class="quick-col">
        <div class="quick-col-title">关于我们</div>
        <div v-for="(item, index) in about_list" :key="index" class="quick-col-item" >
          <a :href="item.href">{{ item.name }}</a>
        </div>
      </div>
      <div class="quick-col">
        <div class="quick-col-title">友情链接</div>
        <div v-for="(item, index) in link_list" :key="index" class="quick-col-item" @click="handleLink(item)">{{ item.name }}</div>
      </div>
      <div class="quick-col">
        <div class="quick-col-title">联系我们</div>
        <div v-for="(item, index) in info_list" :key="index" class="quick-col-item">{{ item.name }}</div>
      </div>
      <div class="quick-qrcode">
        <div v-for="(item, index) in code_list" :key="index" class="quick-qrcode-item">
          <div class="quick-qrcode-item-title">{{ item.name }}</div>
          <div class="quick-qrcode-item-img">
            <img :src="item.path" alt="" />
          </div>
        </div>
      </div>
    </div>
    <div class="record">
      <div class="record-left">
        <a style="color:#fff" target="_blank" rel="noopener" href="http://beian.miit.gov.cn/">粤ICP备17077589号-1©</a>
        2017 广东松科智能科技有限公司·GuangDong Songke Intelligent Technology GO.LTD.
      </div>
      <div class="record-right">
        <img :src="record_url" alt="" />
        <a target="_blank" href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44190002007432">粤公网安备 44190002007432号</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      education_list: [
        {
          name: 'AI 数据仓',
          path: '/education?tab=1',
        },
        {
          name: 'AI 算力云',
          path: '/education?tab=2',
        },
        {
          name: 'AI 图形化',
          path: '/education?tab=3',
        },
        {
          name: 'AI Python',
          path: '/education?tab=4',
        },
        {
          name: 'AI 机器人',
          path: '/education?tab=5',
        },
        {
          name: 'AI 工作坊',
          path: '/education?tab=6',
        },
        {
          name: '教学管理',
          path: '/education?tab=7',
        },
        {
          name: '智能测评',
          path: '/education?tab=8',
        },
        {
          name: '赛事管理',
          path: '/education?tab=9',
        },
      ],
      product_list: [
        {
          name: 'TPU',
          path: '/product/data?id=103',
        },
        {
          name: '机器人',
          path: '/product/data?id=303',
        },
        {
          name: '实验箱',
          path: '/product/data?id=401',
        },
        {
          name: '训推一体机',
          path: '/product/data?id=501',
        },
        {
          name: 'AI 编程电脑',
          path: '/product/data?id=603',
        },
      ],
      scheme_list: [
        {
          name: '基础',
          path: '/scheme?tab=1',
        },
        {
          name: '高校',
          path: '/scheme?tab=2',
        },
        {
          name: '校外培训',
          path: '/scheme?tab=3',
        },
        {
          name: '算力中心',
          path: '/scheme?tab=4',
        },
      ],
      about_list: [
        {
          name: '公司简介',
          path: '/about?tab=brief',
          href: '/about#brief',
        },
        {
          name: '企业文化',
          path: '/about?tab=culture',
          href: '/about#culture',
        },
        {
          name: '业务版图',
          path: '/about?tab=map',
          href: '/about#map',
        },
        {
          name: '发展历程',
          path: '/about?tab=history',
          href: '/about#history',
        },
        {
          name: '荣誉资质',
          path: '/about?tab=honor',
          href: '/about#honor',
        },
        {
          name: '联系我们',
          path: '/about?tab=open',
          href: '/about#open',
        },
      ],
      link_list: [
        // {
        //   name: '开发者社区',
        //   path: 'https://dc.aispore.cn',
        // },
        // {
        //   name: '教育社区',
        //   path: 'https://www.aispore.cn/home',
        // },
        // {
        //   name: 'loongson生态中心',
        //   path: 'https://www.loongson.cn/',
        // },
        {
          name: '龙芯开源社区',
          path: 'http://www.loongnix.cn/zh/',
        },
        {
          name: '飞腾',
          path: 'https://www.phytium.com.cn/developer/'
        },
        {
          name: '申威',
          path: 'http://www.swcpu.cn/'
        },
        {
          name: '兆芯',
          path: 'https://www.zhaoxin.com/kfzzc.aspx?nid=31&typeid=131',
        },
        {
          name: '海光',
          path: 'https://www.hygon.cn/index',
        },
        {
          name: '昇思',
          path: 'https://www.mindspore.cn/',
        },
        // {
        //   name: '昇腾',
        //   path: 'https://www.hiascend.com/',
        // },
        {
          name: '鸿蒙',
          path: 'https://www.harmonyos.com/',
        }
      ],
      info_list: [
        {
          name: '地址：广东省东莞市松山湖科技二路5号2栋1单元501',
          path: '',
        },
        {
          name: '电话：0769-26623129',
          path: '',
        },
      ],
      code_list: [
        {
          name: '官方公众号',
          path: require('@/assets/qrCode/official.png'),
        },
        {
          name: '官方视频号',
          path: require('@/assets/qrCode/video.png'),
        },
      ],
    };
  },
  computed: {
    record_url() {
      return require('@/assets/logo/record.png');
    },
  },
  methods: {
    // 点击
    handleClick(item) {
      this.$router.push({
        path: item.path,
      });
    },
    // 外部链接
    handleLink(item) {
      window.open(item.path, '_blank');
    },
  },
};
</script>

<style lang="less" scoped>
@import '../../assets/styles/variables.less';
.footer {
  color: @footer-font-color;
  .quick {
    background-color: @footer-background-color;
    display: flex;
    justify-content: space-around;
    text-align: left;
    flex-wrap: wrap;
    padding: 0 5%;
    padding-top: 60px;
    .quick-col {
      padding: 0 5px;
      .quick-col-title {
        font-size: @font-18;
        margin-bottom: 16px;
      }
      .quick-col-item {
        font-size: @font-12;
        margin-bottom: 16px;
        cursor: pointer;
        a {
          color: #FFFFFF;
          text-decoration: none;
        }
        a:hover {
          color: #00a8cd;
        }
      }
      .quick-col-item:hover {
        color: #00a8cd;
      }
    }
    .quick-qrcode {
      display: flex;
      flex-direction: row;
      .quick-qrcode-item {
        margin-right: 30px;
        .quick-qrcode-item-title {
          font-size: @font-18;
          text-align: center;
          margin-bottom: 16px;
        }
        .quick-qrcode-item-img {
          width: 124px;
          height: 124px;
          img {
            width: 100%;
            height: 100%;
            margin: 0;
            padding: 0;
          }
        }
      }
    }
  }
  .record {
    display: flex;
    justify-content: space-around;
    align-items: center;
    background-color: @footer-background-color-dark;
    padding: 23px 0;
    .record-left {
      font-size: @font-14;
    }
    .record-right {
      display: flex;
      align-items: center;
      img {
        width: 20px;
        height: 20px;
        padding: 0;
        margin: 0;
        margin-right: 5px;
      }
      a {
        font-size: @font-14;
        color: @footer-font-color;
        padding: 0;
        margin: 0;
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/views/components/footer.vue